/* This File is for {purpose} */

<template>
  <v-layout wrap justify-start pa-2 pa-sm-4 pa-lg-8>
    <v-flex xs12>
      <v-layout wrap justify-start py-4>
        <v-flex xs12>
          <v-card outlined class="app-border-color" rounded="lg">
            <v-layout wrap justify-start pa-4>
              <v-flex xs6 sm4 lg3>
                <span class="subtitle-2">
                  {{ $t("form.name") }}
                </span>
                <br />
                <span class="title-3">
                  {{ ward.name }}
                </span>
              </v-flex>
              <v-flex xs6 sm4 lg3>
                <span class="subtitle-2">
                  {{ $t("form.phone") }}
                </span>
                <br />
                <span class="title-3"> {{ ward.phone }} </span>
              </v-flex>
              <v-flex xs6 sm4 lg3 pt-4 pt-sm-0>
                <span class="subtitle-2">
                  {{ $t("form.address") }}
                </span>
                <br />
                <span class="title-3"> {{ ward.address }} </span>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap justify-start pb-4>
        <v-spacer />
        <!--        <v-flex xs6 sm4 lg3 xl2 pt-2 pt-lg-0 pr-2 pr-lg-4>-->
        <!--          <v-card outlined rounded="lg" class="elevated-card">-->
        <!--            <div class="card-line warning"></div>-->
        <!--            <v-layout wrap justify-start pa-4>-->
        <!--              <v-flex xs12>-->
        <!--                <span class="title-1">{{ analytics.open }}</span> <br />-->
        <!--                <span class="subtitle-1 text-no-wrap">-->
        <!--                  {{ $t("status.open") }}-->
        <!--                </span>-->
        <!--              </v-flex>-->
        <!--            </v-layout>-->
        <!--          </v-card>-->
        <!--        </v-flex>-->
        <!--        <v-flex xs6 sm4 lg3 xl2 pt-2 pt-lg-0 pr-2 pr-sm-0 pr-lg-4>-->
        <!--          <v-card outlined rounded="lg" class="elevated-card">-->
        <!--            <div class="card-line green"></div>-->
        <!--            <v-layout wrap justify-start pa-4>-->
        <!--              <v-flex xs12>-->
        <!--                <span class="title-1">{{ analytics.assigned }}</span> <br />-->
        <!--                <span class="subtitle-1">-->
        <!--                  {{ $t("status.assigned") }}-->
        <!--                </span>-->
        <!--              </v-flex>-->
        <!--            </v-layout>-->
        <!--          </v-card>-->
        <!--        </v-flex>-->
        <!--        <v-flex xs6 sm4 lg3 xl2 pt-2 pt-lg-0 pr-2 pr-sm-0 pr-lg-4>-->
        <!--          <v-card outlined rounded="lg" class="elevated-card">-->
        <!--            <div class="card-line blue"></div>-->
        <!--            <v-layout wrap justify-start pa-4>-->
        <!--              <v-flex xs12>-->
        <!--                <span class="title-1">{{ analytics.archived }}</span> <br />-->
        <!--                <span class="subtitle-1">-->
        <!--                  {{ $t("status.archived") }}-->
        <!--                </span>-->
        <!--              </v-flex>-->
        <!--            </v-layout>-->
        <!--          </v-card>-->
        <!--        </v-flex>-->
        <!--        <v-flex xs6 sm4 lg3 xl2 pt-2 pt-lg-0 pr-2 pr-sm-0>-->
        <!--          <v-card outlined rounded="lg" class="elevated-card">-->
        <!--            <div class="card-line red"></div>-->
        <!--            <v-layout wrap justify-start pa-4>-->
        <!--              <v-flex xs12>-->
        <!--                <span class="title-1">{{ analytics.inactive }}</span> <br />-->
        <!--                <span class="subtitle-1">-->
        <!--                  {{ $t("status.deactivated") }}-->
        <!--                </span>-->
        <!--              </v-flex>-->
        <!--            </v-layout>-->
        <!--          </v-card>-->
        <!--        </v-flex>-->
      </v-layout>
      <v-layout wrap justify-start py-4>
        <v-flex xs6 pb-4 class="title-2">
          {{ $t("form.shift") }}
        </v-flex>
        <v-flex xs6 pb-4 class="title-2" text-right>
          <AppExcelExport
            :items="exportData.list"
            :headings="exportData.headings"
            :name="ward.name"
            @click.native="getWardShiftsList(true, false)"
          />
        </v-flex>
        <v-flex xs12 lg4 xl8></v-flex>
        <v-flex xs12 sm12 md12 lg8 xl4>
          <v-layout wrap justify-end>
            <v-flex xs6 sm6 md5 align-self-center>
              <AppDatePicker
                v-model="date_range"
                range
                placeholder="pages.schedules.select_period"
                clearable
                hide-details
                @submit="getWardShiftsList(false, false)"
              />
            </v-flex>
            <v-flex xs6 sm6 md3 text-right align-self-center pa-2 px-2>
              <v-select
                :placeholder="$t('filters.type')"
                :items="SHIFT_STATUS"
                outlined
                dense
                hide-details
                v-model="filter.status"
                item-text="label"
                item-value="key"
                clearable
                @change="getWardShiftsList(false, false)"
              ></v-select>
            </v-flex>
            <v-flex xs6 sm6 md3 text-right align-self-center pa-2 px-2>
              <v-select
                :placeholder="$t('filters.sort_by')"
                :items="sortTypes"
                outlined
                dense
                hide-details
                v-model="filter.sort_by"
                item-text="label"
                item-value="value"
                clearable
                @change="getWardShiftsList(false, false)"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12>
          <AppSimpleTable
            :headings="headings"
            :items="list"
            :pagination="pagination"
            :empty-title="
              $t('messages.info.no_items', {
                type: $t('pages.employees.assignments'),
              })
            "
            @paginate="(val) => (pagination.page = val)"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Helpers from "@/libs/helper/components/helper-functions";
import AppDatePicker from "@/components/AppDatePicker.vue";
import { _SHIFTS, SHIFT_STATUS, _SHIFT_STATUS } from "@/constants/shifts";

export default {
  name: "Ward",
  components: { AppDatePicker },
  data: () => ({
    date_range: null,
    filter: {
      status: null,
      search: null,
      sort_by: ["date"],
      sort_by_dir: ["desc", "asc", "asc"],
    },
    serviceTypes: [
      { label: "Offen", value: 1 },
      { label: "Gebucht", value: 2 },
      { label: "Archiviert", value: 3 },
    ],
    headings: [
      { name: "", value: "index", style: "width:80px" },
      { name: "form.date", value: "date" },
      { name: "form.start_time", value: "startTime" },
      { name: "form.end_time", value: "endTime" },
      { name: "form.shift", value: "shift" },
      { name: "form.assigned_to", value: "assignedTo" },
      { name: "table.status", value: "status" },
      {
        name: "table.actions",
        value: "action",
        style: "max-width:200px",
        options: ["view"],
        view: "service",
      },
    ],

    pagination: {
      per_page: 25,
      page: 1,
      last_page: 1,
      total: 0,
      from: 0,
      to: 0,
    },
    analytics: {
      open: 0,
      assigned: 0,
      archived: 0,
      inactive: 0,
    },
    downloadList: [],
    SHIFT_STATUS,
  }),
  computed: {
    ...mapGetters({
      getWard: "hospital/getWard",
      getWardShift: "hospital/getWardShifts",
    }),
    sortTypes() {
      return [
        { label: this.$t("pages.employees.title"), value: ["first_name"] },
        { label: this.$t("form.date"), value: ["date"] },
        {
          label: `${this.$t("form.name")}, ${this.$t("form.date")}`,
          value: ["first_name", "date"],
        },
        {
          label: `${this.$t("pages.employees.title")}, ${this.$t("form.date")},
          ${this.$t("form.shift")}`,
          value: ["first_name", "date", "shift_id"],
        },
      ];
    },
    ward() {
      const breadCrumbs = [
        {
          name: "wards",
          text: "pages.wards.ward",
        },
        {
          name: this.$route.name,
          params: this.$route.params,
          text: this.getWard?.name,
        },
      ];
      this.$store.commit("app/setBreadCrumbs", breadCrumbs);
      return this.getWard;
    },
    list() {
      return this.getWardShift?.map((itm, index) => {
        return {
          index: this.pagination.from + index,
          id: itm.service_id,
          date: this.$moment(itm.date).format("DD MMM YYYY"),
          startTime: itm.start_time,
          endTime: itm.end_time,
          shift: _SHIFTS[itm.shift_id],
          assignedTo: itm.assigned_to
            ? itm.first_name + " " + itm.last_name
            : "-",
          status: this.getShiftStatus(itm.status).label,
          rowStyle: {
            backgroundColor:
              this.compareDates(itm.date) ||
              itm.assigned_to ||
              itm.status === _SHIFT_STATUS.DEACTIVATED
                ? ""
                : "#ff520045",
          },
        };
      });
    },
    startDate() {
      return this.date_range ? this.date_range[0] : null;
    },
    endDate() {
      return this.date_range ? this.date_range[1] ?? this.date_range[0] : null;
    },
    formattedExportData() {
      return this.downloadList.map((itm, index) => {
        return {
          index: index + 1,
          date: this.$moment(itm.date).format("DD MMM YYYY"),
          startTime: itm.start_time,
          endTime: itm.end_time,
          shift: _SHIFTS[itm.shift_id],
          ward: itm.service?.ward?.name ?? "ward",
          pool: itm.service?.departments.map((dept) => {
            return dept.department?.name ?? "pool";
          }),
          qualification: itm.service?.qualifications.map((qual) => {
            return qual.qualification?.name ?? "Funktion";
          }),
          status: this.getShiftStatus(itm.status).label,
          employee: itm.assigned_to
            ? itm.first_name + " " + itm.last_name
            : "-",
        };
      });
    },
    exportData() {
      return {
        headings: {
          "": "index",
          Datum: "date",
          Start: "startTime",
          Ende: "endTime",
          Schicht: "shift",
          Abteilung: "ward",
          Pool: "pool",
          Funktion: "qualification",
          "Zugeteilt zu": "employee",
        },
        list: this.formattedExportData,
      };
    },
  },
  watch: {
    "pagination.page"() {
      this.getWardShiftsList(false, true);
    },
  },
  created() {
    this.date_range = this.$route.query.date_range || null;
    this.filter.status = parseInt(this.$route.query.status) || null;
    this.date_range = this.$route.query.date_range
      ? Array.isArray(this.$route.query.date_range)
        ? this.$route.query.date_range
        : String(this.$route.query.date_range).split(",") // split by commas if it's a string
      : null;
    this.filter.sort_by = this.$route.query.sort_by
      ? Array.isArray(this.$route.query.sort_by)
        ? this.$route.query.sort_by
        : String(this.$route.query.sort_by).split(",") // split by commas if it's a string
      : ["date"];

    this.pagination.page = parseInt(this.$route.query.page) || 1;

    this.getWardDetails(this.$route.params.id);
    this.getWardShiftsList(false, true);
  },
  methods: {
    ...mapActions({
      getWardDetails: "hospital/getWard",
      getWardShifts: "hospital/getWardShifts",
    }),

    getShiftStatus(shift) {
      return SHIFT_STATUS.find((item) => item.key === shift);
    },
    compareDates(inputDate) {
      const currentDate = this.$moment();
      const input = this.$moment(inputDate, "YYYY-MM-DD");
      return input.isBefore(currentDate);
    },
    updateQueryParams(pagination = false) {
      if (!pagination) this.pagination.page = 1;

      // Convert date_range and sort_by arrays to a single string
      const dateRangeQuery = this.date_range ? this.date_range.join(",") : null;
      const sortByQuery = this.filter.sort_by
        ? this.filter.sort_by.join(",")
        : null;
      this.$router.replace({
        query: {
          date_range: dateRangeQuery,
          status: this.filter.status,
          sort_by: sortByQuery,
          page: this.pagination.page,
        },
      });
    },
    getWardShiftsList(download = false, paginate = false) {
      this.updateQueryParams(paginate);
      const payload = {
        ward_id: this.$route.params.id,
        ...this.pagination,
        ...this.filter,
        from_date: this.startDate,
        to_date: this.endDate,
        download: download,
        fileName: this.ward.name,
      };
      this.getWardShifts(payload).then((res) => {
        if (!download) {
          this.analytics = res.count;
          this.pagination = Helpers.setPagination(res);
        }
        // else this.downloadList = res;
      });
    },
  },
};
</script>

<style scoped>
.v-btn-toggle {
  border-radius: 7px;
}
.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #c0cbe0 !important;
}
.v-btn--active::before,
.v-btn--active:hover::before,
.v-btn--active {
  opacity: 1 !important;
  background-color: #dce8ff;
}
.v-btn-toggle > .v-btn.v-btn {
  opacity: 1;
}
.v-btn:focus::before {
  opacity: 0;
}
.v-btn:hover::before {
  background-color: #dce8ff;
  opacity: 0.34;
}
.v-text-field--outlined >>> fieldset {
  border-color: #c0cbe0 !important;
}
.v-text-field--outlined::v-deep input,
.v-text-field--outlined::v-deep input::placeholder {
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: #9fadc8;
}
</style>
